import { AxiosResponse } from "axios";

import { appConstants } from "../config/app-constants";
import { IDocParams, IFilingDocument, IUploadedDocument } from "../config/interfaces";
import InitApi from "./init";

class DocFilingApi {
	static _instance: DocFilingApi;

	static getInstance = () => {
		if (this._instance) {
			return this._instance;
		}
		this._instance = new DocFilingApi();
		return this._instance;
	};

	_apiSvc;

	constructor() {
		this._apiSvc = InitApi.getInstance();
	}

	uploadFilingDocument = async (data: any): Promise<AxiosResponse> => {
		return this._apiSvc.post(`${appConstants.apiUrl}/file/upload`, data);
	};

	createFilingDocument = async (data: any): Promise<AxiosResponse> => {
		return this._apiSvc.post(`${appConstants.apiUrl}/efiling-document`, data);
	};

	updateFilingDocument = async (data: IFilingDocument, uuid: string): Promise<AxiosResponse> => {
		const response = await this._apiSvc.post(
			`${appConstants.apiUrl}/efiling-document/single/${uuid}`,
			data
		);
		return response.data;
	};

	getFilingDocumentById = async (uuid: string): Promise<AxiosResponse> => {
		return this._apiSvc.get(`${appConstants.apiUrl}/efiling-document/single/:uuid/${uuid}`);
	};

	getFilingDocuments = async (params: IDocParams): Promise<{ records: IUploadedDocument[] }> => {
		const { offset = 0, count = -1, efilingUuid } = params;

		let url = `efiling-document?offset=${offset}`;
		if (count) {
			url += `&count=${count}`;
		}
		if (efilingUuid) {
			url += `&efilingUuid=${efilingUuid}`;
		}

		const response = await this._apiSvc.get(`${appConstants.apiUrl}/${url}`);
		return response.data;
	};

	deleteFilingDocument = async (data: any): Promise<AxiosResponse> => {
		return this._apiSvc.delete(`${appConstants.apiUrl}/efiling-document`, { data });
	};

	downloadFilingDocument = async (path: any): Promise<AxiosResponse> => {
		return this._apiSvc.get(`${appConstants.apiUrl}/file/download?key=${path}`);
	};

	extractForm16Data = async (data: FormData): Promise<AxiosResponse> => {
		return this._apiSvc.post(`${appConstants.extractForm16DataURL}`, data);
	};

	extractStocksData = async (data: FormData): Promise<AxiosResponse> => {
		return this._apiSvc.post(`${appConstants.extractStocksDataURL}`, data);
	};

	extractMutualFundsData = async (data: FormData): Promise<AxiosResponse> => {
		return this._apiSvc.post(`${appConstants.extractMutualFundsDataURL}`, data);
	};
}

export default DocFilingApi;
